import axios from 'axios'

const Config = {
  baseURL: window.CMSAXIOS,
  siteId:  window.SITEID,
}

export default function request(options={}){
  const defaultOptions = {
    baseURL: Config.baseURL,
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...options };
  if(options.data){
    newOptions.data = {
      siteId: Config.siteId,
      ...options.data
    }
  }
  newOptions.headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    ...newOptions.headers,
  };
  // validateStatus
  return axios(newOptions)
}